import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useLanguage } from "../../hooks/useLanguage";

export type SlugCheckState =
  | { status: "idle" }
  | { status: "checking" }
  | { status: "available" }
  | { status: "unavailable"; message: string }
  | { status: "error"; message: string };

type SlugFieldProps = {
  slug: string;
  hostLabel: string;
  status: SlugCheckState;
  onChange: (value: string) => void;
  onBlur: () => void;
};

export function SlugField({
  slug,
  hostLabel,
  status,
  onChange,
  onBlur,
}: SlugFieldProps) {
  const { t } = useLanguage();

  return (
    <div className="space-y-2">
      <Label htmlFor="slug">{t.pageBuilder.form.slug.label}</Label>
      <div className="flex flex-col gap-2">
        <div className="flex rounded-lg border border-neutral-200 overflow-hidden">
          <span className="bg-neutral-100 px-3 py-2 text-sm text-neutral-500 hidden sm:inline">
            {hostLabel}/
          </span>
          <Input
            id="slug"
            value={slug}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            placeholder={t.pageBuilder.form.slug.placeholder}
            className="border-0 focus-visible:ring-0"
            required
          />
        </div>
        <p className="text-xs text-neutral-500">
          {t.pageBuilder.form.slug.help}
        </p>
        {status.status === "checking" && (
          <p className="text-xs text-neutral-500">
            {t.pageBuilder.form.slug.checking}
          </p>
        )}
        {status.status === "unavailable" && (
          <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-600">
            {status.message}
          </div>
        )}
        {status.status === "error" && (
          <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-600">
            {status.message}
          </div>
        )}
      </div>
    </div>
  );
}
